module.exports = __webpack_public_path__ + "static/media/keyvisual_sipgate_1280x1280_black.658ac451.mp4";